<template>
    <div>
        <div id="initial-transition-container">
            <div class="loader"></div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'initialTransitionPage',
    }
</script>
<style lang="scss">
    @import '@/assets/sass/views/initialTransitionView.scss';
</style>